import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ConstantsService } from '../../constants/constants.service';
import { Router, RouterLink } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { HttpService } from '../../services/http.service';
import { Subscription } from 'rxjs';
import { NotificationWebsocketService } from '../../services/notification-websocket.service';
import { VisitUpdateService } from '../../services/VisitUpdateService';
import { ProfileUpdateService } from '../../services/ProfileUpdateService';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [DatePipe, RouterLink, CommonModule, FormsModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HeaderComponent implements OnInit {

  notificationSub: Subscription | null = null;
  

  // roleName: string = '';
  userRole: string = 'Admin'; 

  originalRole: string = '';
  roles: any = [];
  unreadCount: number = 0;
  showNotifications: boolean = false;
  notifications: any = [];
  user: any;
  currentDate: Date = new Date();
  isAdmin: boolean = false;
  openScanner = false;
  userId: string = '';

  constructor(public httpService: HttpService, public constants: ConstantsService, private router: Router, private toastr: ToastrService, private notificationSocket: NotificationWebsocketService, private visitUpdateService: VisitUpdateService, private profileUpdateService: ProfileUpdateService) { }

  ngOnInit() {
    setInterval(() => {
      this.currentDate = new Date();
    }, 1000);

    console.log(this.userRole);
    
    this.user = this.constants.getSession();
    this.originalRole = this.constants.getRoleSession();

    if (this.user) {
      // this.roleName = this.user.role?.name || '';
      this.isAdmin = this.user.isAdmin;

      // ✅ Populate role dropdown dynamically
      // this.roles = this.user.roles?.map((r: any) => r.name) || [];
      this.roles = this.user.roles || [];

      const currentRole = this.user.role;
       this.userRole = this.roles.find((r: any) => r.name === currentRole?.name)?.name || 'Admin';
      // Notification WebSocket connection
      if (this.user && this.user.email) {
        this.notificationSocket.connect(this.user.email);

        this.notificationSub = this.notificationSocket.getNotifications().subscribe(
          (notification) => {
            const title = `🔔 ${notification.title}`;
            const message = notification.message;
            this.toastr.info(message, title, {
              enableHtml: true,
              timeOut: 5000,
              closeButton: true,
              positionClass: 'toast-bottom-right',
            });
            this.loadUnreadCount();
            this.notificationsList();
            this.playNotificationSound();
            this.visitUpdateService.notifyVisitUpdated();
          }
        );
      }
    }

    // this.loadUnreadCount();
    this.notificationsList();
    if (this.user) {
      this.userId = this.user.usersId;
    }
    this.getUserDetail(this.userId);
    this.profileUpdateService.profileUpdated$.subscribe(() => {
      if (this.userId) {
        this.getUserDetail(this.userId); // ✅ reload user details (including photo)
      }
    });

  }



  logout() {
    this.constants.clearSession();
    this.router.navigate(['/dashboard']);
  }

  toggleSidebar() {
    const wrapper = document.getElementById('main-wrapper');
    if (wrapper) {
      wrapper.classList.toggle('mini-sidebar');
      wrapper.classList.toggle('show-sidebar');

      if (wrapper.classList.contains('mini-sidebar')) {
        wrapper.setAttribute('data-sidebartype', 'mini-sidebar');
      } else {
        wrapper.setAttribute('data-sidebartype', 'full');
      }
    }
  }
  closeSidebar() {
    const wrapper = document.getElementById('main-wrapper');
    if (wrapper) {
      wrapper.classList.remove('show-sidebar');
    }
  }

  playNotificationSound() {
    const audio = new Audio('assets/images/notification.mp3');
    audio.volume = 1.0; // Set volume (0.0 to 1.0)
    audio.play().catch(error => {
      console.error('Error playing sound:', error);
    });
  }

  // onRoleChange(event: any) {

  //   if (!this.selectedRole) return;

  //   const keyRole = this.selectedRole.keyRole;
  //   console.log('Selected role:', keyRole);
  //   this.httpService.getRequest(this.constants.SERVER_URLS['ROLE_OBJECT'] + '/' + keyRole).subscribe((res: any) => {
  //     if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
  //       const storedUser = this.constants.getSession();
  //       storedUser.role = res.result;
  //       this.constants.setSession(storedUser);
  //       this.constants.setRoleSession(res.result);
  //       this.user = storedUser;

  //       this.httpService.getRequest(this.constants.SERVER_URLS['SET_ACTIVE_ROLE'] + '/' + keyRole).subscribe((tokenRes: any) => {
  //         if (tokenRes.status === this.constants.RESPONSE_CODES['SUCCESS']) {
  //           storedUser.sessionToken = tokenRes.result;
  //           this.constants.setSession(storedUser);

  //           const routeMap: { [key: string]: string } = {
  //             'ADMIN': '/users',
  //             'HOST': '/dashboard',
  //             'RECEPTION': '/todays-visits',
  //             'SECURITY': '/todays-visits',
  //           };

  //           const route = routeMap[keyRole]
  //             ? routeMap[keyRole]
  //             : this.constants.hasModulePermission('Visit', 'LIST')
  //               ? '/dashboard'
  //               : '/settings';
  //           this.router.navigate([route]).then(() => window.location.reload());
  //         }
  //       });

  //     }
  //   });
  // }



  loadUnreadCount() {
    this.httpService.getRequest(this.constants.SERVER_URLS['NOTIFICATION_COUNT']).subscribe((res: any) => {
      if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
        this.unreadCount = res.result;
      }
    });
  }

  notificationsList() {
    this.httpService.getRequest(this.constants.SERVER_URLS['NOTIFICATION_LIST']).subscribe((res: any) => {
      if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
        this.notifications = res.result;
        this.unreadCount = this.notifications.filter((n: any) => !n.seen).length;
      }
    });
  }

  toggleNotificationPanel() {
    this.showNotifications = !this.showNotifications;
    if (this.showNotifications) {
      this.notificationsList();
    }
  }

  markAllAsRead() {
    if (this.notifications && this.notifications.length > 0) {
      this.httpService.putRequest(this.constants.SERVER_URLS['MARK_ALL_AS_READ'], {}).subscribe((res: any) => {
        if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
          this.toastr.success(res.message);
          this.notificationsList();
        } else {
          this.toastr.error('Failed to mark all notifications as read');
        }
      }, (error: any) => {
        this.toastr.error('Error marking notifications as read');
      });
    }
  }

  onNotificationClick(notification: any): void {
    if (!notification || !notification.notificationId) return;

    this.httpService.getRequest(this.constants.SERVER_URLS['NOTIFICATION'] + '/' + notification.notificationId).subscribe(
      (res: any) => {
        if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
          this.showNotifications = false;
          this.notificationsList();
          switch (notification.type) {
            case 'Visit_Submission':
              this.router.navigate(['/visit-list'], {
                queryParams: { status: 'Pending_Approvals' }
              });
              break;
            default:
              this.router.navigate(['/notifications']);
          }
        } else {
          this.toastr.error('Failed to update notification status');
        }
      },
      error => {
        this.toastr.error('Error marking notification as read');
      }
    );
  }
  viewAllNotifications() {
    this.showNotifications = false;
    this.router.navigate(['/notifications']);
  }

  handleScan(event: any) {
    const result = event?.detail?.result;
    if (result) {
      console.log('Scanned from header:', result);
    }
    this.openScanner = false;
  }
  getUserDetail(userId: any) {
    this.httpService
      .getRequest(this.constants.SERVER_URLS['USER_DETAILS'] + userId)
      .subscribe((res: any) => {
        if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
          this.user = res.result;
        } else {
          this.toastr.error(res.message, 'Error');
        }
      });
  }
  @ViewChild('roleDropdown') roleDropdown!: ElementRef<HTMLSelectElement>;

  openRoleDropdown() {
    console.log('Opening role dropdown');
    if (this.roleDropdown && this.roleDropdown.nativeElement) {
      this.roleDropdown.nativeElement.click();
    }
  }
}